import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import DataState from 'app/src/components/DataState';
import { ContentContainer } from 'app/src/elements';

import EditPayment from './edit';

import { TXN } from '../Txns/queries';

const Payment = () => {
  const { id } = useParams();

  const { data, refetch } = useQuery(TXN, { variables: { id } });

  if (!data) { return <DataState.Loading />; }

  return (
    <ContentContainer>
      <EditPayment
        txn={data.txn}
        refetch={refetch}
        setShowModal={() => {}}
      />
    </ContentContainer>
  );
};

export default Payment;
